import { render, staticRenderFns } from "./testingNoGroup.vue?vue&type=template&id=854d1c7c&"
import script from "./testingNoGroup.vue?vue&type=script&lang=js&"
export * from "./testingNoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports